import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TAgent } from '../types/agent.type';
import { useMutation } from '@tanstack/react-query';
import { TypedMutationConfig } from '@/lib/react-query';

/**
 *
 */
export const DeleteInviteAgentValidationSchema = z.object({
  invitationId: z.string({ message: 'Invitation ID is required' }).min(1),
});
export type TDeleteInviteAgentValidation = z.infer<typeof DeleteInviteAgentValidationSchema>;
export type TDeleteInviteAgentPayload = TDeleteInviteAgentValidation;
export type TDeleteInviteAgentResponse = ApiResponse<TAgent>;

export const deleteInviteAgent = (payload: TDeleteInviteAgentPayload): Promise<TDeleteInviteAgentResponse> => {
  const url = `/invitation/${payload.invitationId}`;

  return axiosInstance.delete(url);
};

/**
 *  Return query key for delete invite agent
 */
type UseDeleteInviteAgentOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteInviteAgent, AxiosErrorCustom>;
};

export const useDeleteInviteAgent = ({ mutationConfig }: UseDeleteInviteAgentOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation<TDeleteInviteAgentResponse, AxiosErrorCustom, TDeleteInviteAgentPayload>({
    mutationFn: deleteInviteAgent,
    ...restConfig,
  });
};
